<script setup lang="ts">
/**
 * ORBIS Admin - Root Component
 */
import ToastContainer from '@/components/common/ToastContainer.vue';
</script>

<template>
  <router-view />
  <ToastContainer />
</template>

<style>
@tailwind base;
@tailwind components;
@tailwind utilities;
</style>
